export default "__VITE_ASSET__MLSp1yaQ__"